import { createContext, useContext } from "react";

export interface MedicalChronologySearchContextValue {
  searchQuery: string;
  setSearchQuery: (query: string) => void;
  debouncedSearchQuery: string;
}

const MedicalChronologySearchContext = createContext<
  MedicalChronologySearchContextValue | undefined
>(undefined);

export const MedicalChronologySearchProvider = MedicalChronologySearchContext.Provider;

export const useMedicalChronologySearch = (): MedicalChronologySearchContextValue => {
  const value = useContext(MedicalChronologySearchContext);
  if (!value) {
    throw new Error("useMedicalChronologySearch must be used within MedicalChronologyProvider");
  }
  return value;
};
